import { fullwidthGridColumn, grid } from '../../../../utils/grid'
import Image, { ImageProps } from '../../../atoms/image/Image'
import React, { FunctionComponent } from 'react'
import { mediaQueries } from '../../../../utils/mediaQueries'
import { rem } from '../../../../utils/rem'
import { SectionProps } from '../Sections'
import { spacing } from '../../../../utils/spacing'
import { spacings } from '../../../../tokens/Spacings'
import styled from 'styled-components'

export interface ImageSectionProps extends ImageProps, SectionProps {}

const ImageSection: FunctionComponent<ImageSectionProps> = ({
  className,
  url,
}) => (
  <StyledImageSection className={className}>
    <ImageWrapper>
      <Image url={url} />
    </ImageWrapper>
  </StyledImageSection>
)

const StyledImageSection = styled.div`
  ${grid()}
  ${spacing()}
`

const ImageWrapper = styled.div`
  ${fullwidthGridColumn()}
  margin: 0 -${rem(spacings.side.root / 2)};

  ${mediaQueries.tablet} {
    margin: 0 -${rem(spacings.side.tablet / 2)};
  }

  ${mediaQueries.desktop} {
    margin: 0;
  }
`

export default ImageSection
